import { useModel } from "@umijs/max";
import { Select } from "antd";
export default function SiteSelector() {
  const { siteList, currentSite, setCurrentSite } = useModel("site");

  return (
    <Select
      className="h-full px-0 w-20"
      options={siteList}
      value={currentSite}
      onChange={(val) => {
        setCurrentSite(val);
        localStorage.setItem("currentSite", val.toString());
      }}
    />
  );
}
